var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoCondensed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#232323;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213,253H43c-22.1,0-40-17.9-40-40V43C3,20.9,20.9,3,43,3h170c22.1,0,40,17.9,40,40v170 C253,235.1,235.1,253,213,253z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103,176.9V96h44.9l0,53.9l0,0c0,1.5-1.2,2.7-2.7,2.7l0,0h-7.2v11.3h34.5v-11.3l-7.2,0c-1.5,0-2.7-1.2-2.7-2.7 v-4.1h0l0-104.7c0-1.4,1.2-2.6,2.6-2.7l7.2,0V27.2h-34.5v11.2h7.2c1.5,0,2.7,1.2,2.7,2.7v6.1h0v33.2H103V41.1l0,0 c0-1.5,1.2-2.7,2.7-2.7h0h7.2V27.2H78.4v11.2H85l0.5,0c1.5,0,2.6,1.2,2.7,2.6v0.5v135.2H69.6c-0.4,0-0.8,0-1.1,0 c-5.3,0-9.7,4.3-9.7,9.7c0,2.3,0.8,4.4,2.2,6.1l0,0l28.1,36c0.1,0.1,0.6,0.1,0.6,0.1H103v-37.1h153.2v-14.8H103z M88.2,203.6 l-9.3-11.9h9.3V203.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCondensed);
export default __webpack_public_path__ + "static/media/logoCondensed.486173fcc0343015be868c6881ba8f7a.svg";
export { ForwardRef as ReactComponent };